import { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import loginApi from "../../Services/Login";
import settingsApi from "Services/Settings";
import { showSnackbar } from "../../Redux/SnackBar/actions";
import { showLoader, hideLoader } from "../../Redux/Loader/actions";
import { setNewSiteLogo } from "Redux/SiteSettings/actions";
import { setNewtimezone, setSystemlatitude, setSystemlongitude } from "Redux/TimeZone/actions";
import { setAuthentication } from "../../Redux/Authentication/actions";
import { LocaleSelector } from "SharedComponents/LocaleSelector";
import logo from "../../assets/IconMetuaa.png";
import covoiturageImage from "../../assets/image-covoiturage-2.png";
import "./LoginPage.css";

function SearchIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="11" cy="11" r="7.5" />
      <path d="m16.5 16.5 4.5 4.5" />
    </svg>
  );
}

function UserIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="7.5" r="3.5" />
      <path d="M4.5 20a7.5 7.5 0 0 1 15 0" />
    </svg>
  );
}

function MenuChevronIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m9 6 6 6-6 6" />
    </svg>
  );
}

function EmailIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="6" width="16" height="12" rx="2.5" />
      <path d="m5.5 8 6.5 5 6.5-5" />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="5" y="10" width="14" height="10" rx="2.5" />
      <path d="M8.5 10V8.5a3.5 3.5 0 1 1 7 0V10" />
    </svg>
  );
}

function EyeIcon({ visible }) {
  if (visible) {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="m3 3 18 18" />
        <path d="M10.6 10.7A2.8 2.8 0 0 0 12 14.8a2.8 2.8 0 0 0 2.2-.9" />
        <path d="M9.7 5.3A10.1 10.1 0 0 1 12 5c6.2 0 9.2 5 9.2 5a16 16 0 0 1-3.1 3.8" />
        <path d="M6.3 6.3C4 8 2.8 10 2.8 10S5.8 15 12 15c1.2 0 2.4-.2 3.4-.5" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M2.8 12s3-5 9.2-5 9.2 5 9.2 5-3 5-9.2 5-9.2-5-9.2-5Z" />
      <circle cx="12" cy="12" r="2.5" />
    </svg>
  );
}

function ShieldIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 3.5 5.5 6.3v5.3c0 4.5 2.8 7.9 6.5 8.9 3.7-1 6.5-4.4 6.5-8.9V6.3L12 3.5Z" />
      <path d="m9.5 11.9 1.5 1.5 3.3-3.3" />
    </svg>
  );
}

function ChatIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3.5" y="5" width="17" height="11" rx="5.5" />
      <path d="m8 16-1.4 2.5 3-1.8" />
      <circle cx="9" cy="10.5" r=".8" fill="currentColor" stroke="none" />
      <circle cx="12" cy="10.5" r=".8" fill="currentColor" stroke="none" />
      <circle cx="15" cy="10.5" r=".8" fill="currentColor" stroke="none" />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="8" y="3.5" width="8" height="17" rx="2.2" />
      <path d="M11 17.5h2" />
    </svg>
  );
}

function GoogleIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#EA4335" d="M12 10.2v3.8h5.4a4.5 4.5 0 0 1-1.9 3l3.1 2.4c1.8-1.6 2.9-4 2.9-7 0-.7-.1-1.4-.2-2.2H12Z" />
      <path fill="#34A853" d="M12 22c2.5 0 4.7-.8 6.2-2.3l-3.1-2.4c-.9.6-1.9.9-3.1.9-2.4 0-4.5-1.6-5.2-3.8l-3.2 2.5A10 10 0 0 0 12 22Z" />
      <path fill="#4A90E2" d="M6.8 14.4a6 6 0 0 1 0-4.7L3.6 7.2a10 10 0 0 0 0 9.7l3.2-2.5Z" />
      <path fill="#FBBC05" d="M12 5.8c1.4 0 2.7.5 3.7 1.4l2.7-2.7A9.7 9.7 0 0 0 12 2 10 10 0 0 0 3.6 7.2l3.2 2.5c.7-2.3 2.8-3.9 5.2-3.9Z" />
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="10" fill="#1877F2" />
      <path
        fill="#fff"
        d="M13.3 8.5h1.8V6h-2c-2.4 0-3.8 1.5-3.8 3.9v1.5H7v2.7h2.2V18h3v-3.9h2.5l.4-2.7h-2.9v-1.2c0-.8.2-1.7 1.1-1.7Z"
      />
    </svg>
  );
}

function FooterFacebookIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M13.4 20v-7h2.4l.4-2.7h-2.8V8.6c0-.8.2-1.5 1.3-1.5h1.6V4.7c-.3 0-1.1-.1-2.1-.1-2.1 0-3.5 1.2-3.5 3.6v2.1H8.4V13h2.3v7h2.7Z" />
    </svg>
  );
}

function FooterXIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6 5h3.1l3.7 5 4-5H19l-5.2 6.5L19.4 19h-3.1l-4.1-5.5L7.8 19H5.6l5.5-6.9L6 5Z" />
    </svg>
  );
}

function FooterYoutubeIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M21 12c0 2.6-.3 4.2-.7 5-.2.5-.6.9-1.1 1.1-.9.4-3.5.7-7.2.7s-6.3-.3-7.2-.7c-.5-.2-.9-.6-1.1-1.1-.4-.8-.7-2.4-.7-5s.3-4.2.7-5c.2-.5.6-.9 1.1-1.1.9-.4 3.5-.7 7.2-.7s6.3.3 7.2.7c.5.2.9.6 1.1 1.1.4.8.7 2.4.7 5Z" />
      <path fill="#fff" d="m10 8.8 5 3.2-5 3.2V8.8Z" />
    </svg>
  );
}

function FooterInstagramIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="5" y="5" width="14" height="14" rx="4" />
      <circle cx="12" cy="12" r="3.3" />
      <circle cx="16.6" cy="7.6" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

function FooterTiktokIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M14.2 4.5c.5 1.6 1.7 2.8 3.3 3.2v2.4a6.3 6.3 0 0 1-3.1-.8v5.1a4.8 4.8 0 1 1-4.8-4.8c.3 0 .7 0 1 .1v2.5a2.5 2.5 0 1 0 1.5 2.2V4.5h2.1Z" />
    </svg>
  );
}

const getFooterColumns = (intl) => [
  {
    title: intl.formatMessage({ id: "footer.compare.title" }),
    links: [
      { label: "Yaoundé → Douala" },
      { label: "Bafoussam → Yaoundé" },
      { label: "Douala → Kribi" },
      { label: "Yaoundé → Garoua" },
      { label: "Bamenda → Douala" },
      { label: intl.formatMessage({ id: "footer.compare.allRoutes" }), accent: true },
      { label: intl.formatMessage({ id: "footer.compare.allDestinations" }), accent: true },
    ],
  },
  {
    title: intl.formatMessage({ id: "footer.bus.title" }),
    links: [
      { label: "Bus Yaoundé → Douala" },
      { label: "Bus Yaoundé → Bafoussam" },
      { label: "Bus Douala → Limbé" },
      { label: "Bus Yaoundé → Ngaoundéré" },
      { label: "Bus Garoua → Maroua" },
      { label: intl.formatMessage({ id: "footer.bus.popularLines" }), accent: true },
      { label: intl.formatMessage({ id: "footer.bus.popularDestinations" }), accent: true },
    ],
  },
  {
    title: intl.formatMessage({ id: "footer.about.title" }),
    links: [
      { label: intl.formatMessage({ id: "footer.about.whoWeAre" }) },
      { label: intl.formatMessage({ id: "footer.about.howItWorks" }) },
      { label: intl.formatMessage({ id: "footer.about.travelCheaper" }) },
      { label: intl.formatMessage({ id: "footer.about.helpCenter" }) },
      { label: intl.formatMessage({ id: "footer.about.tips" }) },
      { label: intl.formatMessage({ id: "footer.about.blog" }) },
      { label: intl.formatMessage({ id: "footer.about.press" }) },
    ],
  },
];

function BbcHeader({ intl }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!isMenuOpen) {
      return undefined;
    }

    const handleOutsideClick = (event) => {
      if (!menuRef.current?.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isMenuOpen]);

  return (
    <header className="bbc-nav-shell">
      <div className="bbc-container bbc-nav-container">
        <div className="bbc-nav">
          <Link to="/" className="bbc-logo" aria-label="METUA'A">
            <img src={logo} alt="Logo METUA'A" className="bbc-logo-image" />
            <span>METUA&apos;A</span>
          </Link>

          <nav className="bbc-main-links" aria-label="Navigation principale">
            <a href="/">{intl.formatMessage({ id: "header.nav.carpool" })}</a>
            <a href="/">{intl.formatMessage({ id: "header.nav.bus" })}</a>
            <a href="/">{intl.formatMessage({ id: "header.nav.train" })}</a>
          </nav>

          <div className="bbc-right">
            <button
              type="button"
              className="bbc-icon-btn"
              aria-label={intl.formatMessage({ id: "header.search.ariaLabel" })}
            >
              <SearchIcon />
            </button>
            <a href="/" className="bbc-propose">{intl.formatMessage({ id: "header.proposeTrip" })}</a>
            <LocaleSelector />
            <button
              type="button"
              className="bbc-avatar-btn"
              aria-label="Ouvrir le menu utilisateur"
              aria-expanded={isMenuOpen}
              onClick={() => setIsMenuOpen((current) => !current)}
            >
              <span className="bbc-avatar" aria-hidden="true">
                <UserIcon />
              </span>
            </button>
          </div>

          {isMenuOpen ? (
            <div className="bbc-user-menu" ref={menuRef}>
              <Link to="/" className="bbc-user-menu-item" onClick={() => setIsMenuOpen(false)}>
                <span>{intl.formatMessage({ id: "header.menu.login" })}</span>
                <MenuChevronIcon />
              </Link>
              <Link to="/" className="bbc-user-menu-item" onClick={() => setIsMenuOpen(false)}>
                <span>{intl.formatMessage({ id: "header.menu.signup" })}</span>
                <MenuChevronIcon />
              </Link>
            </div>
          ) : null}
        </div>
      </div>
    </header>
  );
}

function FooterArt() {
  return (
    <div className="bbc-footer-art" aria-hidden="true">
      <div className="bbc-hill bbc-hill-left" />
      <div className="bbc-hill bbc-hill-right" />
      <div className="bbc-cloud bbc-cloud-left" />
      <div className="bbc-cloud bbc-cloud-right" />
      <div className="bbc-tree">
        <span className="bbc-tree-trunk" />
        <span className="bbc-tree-top" />
      </div>
      <div className="bbc-bus-illustration">
        <span className="bbc-bus-window" />
        <span className="bbc-bus-wheel bbc-bus-wheel-left" />
        <span className="bbc-bus-wheel bbc-bus-wheel-right" />
      </div>
      <div className="bbc-train-illustration">
        <span className="bbc-train-window" />
        <span className="bbc-train-wheel bbc-train-wheel-left" />
        <span className="bbc-train-wheel bbc-train-wheel-right" />
      </div>
      <span className="bbc-bird bbc-bird-one" />
      <span className="bbc-bird bbc-bird-two" />
    </div>
  );
}

function BbcFooter({ intl }) {
  const footerColumns = getFooterColumns(intl);

  return (
    <footer className="bbc-footer">
      <div className="bbc-footer-inner">
        <div className="bbc-footer-top">
          <div className="bbc-footer-grid">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4>{column.title}</h4>
                <ul>
                  {column.links.map((link) => (
                    <li key={link.label}>
                      <a href="/" className={link.accent ? "is-accent" : ""}>{link.label}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="bbc-footer-side">
            <div className="bbc-social" aria-label={intl.formatMessage({ id: "footer.social.ariaLabel" })}>
              <a href="/" aria-label="Facebook"><FooterFacebookIcon /></a>
              <a href="/" aria-label="X"><FooterXIcon /></a>
              <a href="/" aria-label="YouTube"><FooterYoutubeIcon /></a>
              <a href="/" aria-label="Instagram"><FooterInstagramIcon /></a>
              <a href="/" aria-label="TikTok"><FooterTiktokIcon /></a>
            </div>
            <FooterArt />
          </div>
        </div>

        <div className="bbc-footer-bottom">
          <div className="bbc-footer-links">
            <a href="/">{intl.formatMessage({ id: "footer.legal.transparency" })}</a>
            <a href="/">{intl.formatMessage({ id: "footer.legal.info" })}</a>
            <a href="/">{intl.formatMessage({ id: "footer.legal.cookies" })}</a>
          </div>
          <div className="bbc-footer-brand">{intl.formatMessage({ id: "footer.brand" })}</div>
        </div>
      </div>
    </footer>
  );
}

const getAuthPayload = (responseData) => responseData?.data || responseData || {};

const getAuthToken = (authData) =>
  authData?.accessToken ||
  authData?.token ||
  authData?.tokens?.accessToken ||
  authData?.auth?.accessToken;

const persistAuthSession = (authData) => {
  const token = getAuthToken(authData);

  if (!token) {
    return null;
  }

  const user = authData?.user || {};

  localStorage.setItem("isAuthenticated", true);
  localStorage.setItem("token", token);
  localStorage.setItem("tokenExpiration", Date.now() + 1 * 24 * 60 * 60 * 1000);
  localStorage.setItem("userid", user?.id || authData?.id || "");
  localStorage.setItem("userType", user?.userType || authData?.userType || "");

  if (authData?.sub_companyName) {
    localStorage.setItem("subcompany", authData.sub_companyName);
  } else {
    localStorage.removeItem("subcompany");
  }

  return token;
};

const Login = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form, setForm] = useState({ email: "", password: "" });
  const [rememberMe, setRememberMe] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const trustItems = [
    {
      title: intl.formatMessage({ id: "login.trust.confidence.title" }),
      text: intl.formatMessage({ id: "login.trust.confidence.text" }),
      Icon: ShieldIcon,
    },
    {
      title: intl.formatMessage({ id: "login.trust.chat.title" }),
      text: intl.formatMessage({ id: "login.trust.chat.text" }),
      Icon: ChatIcon,
    },
    {
      title: intl.formatMessage({ id: "login.trust.booking.title" }),
      text: intl.formatMessage({ id: "login.trust.booking.text" }),
      Icon: PhoneIcon,
    },
  ];

  const getMasterValues = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(setNewSiteLogo(res?.data?.data?.siteLogo));
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    settingsApi.getMasterValues().then(onSuccess, onFailure);
  }, [dispatch]);

  const getBusinessValues = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(setNewtimezone(res?.data?.data?.timeZone));
        dispatch(setSystemlatitude(res?.data?.data?.latitude));
        dispatch(setSystemlongitude(res?.data?.data?.longitude));
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    settingsApi.getBusinessSettings().then(onSuccess, onFailure);
  }, [dispatch]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setError("");
    dispatch(showLoader("Loading please wait..."));

    try {
      const res = await loginApi.login({
        email: form.email,
        password: form.password,
        userType: "ADMIN",
      });
      const authData = getAuthPayload(res?.data);
      const token = persistAuthSession(authData);

      if (!token) {
        throw new Error("Connexion reussie, mais aucun token d'authentification n'a ete recu.");
      }

      dispatch(hideLoader());
      dispatch(setAuthentication(authData));
      dispatch(
        showSnackbar({
          message: res?.data?.message || "Logged in successfully",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "success",
        })
      );

      getMasterValues();
      getBusinessValues();
      navigate("/");
    } catch (exception) {
      dispatch(hideLoader());
      const message = exception?.response?.data?.message || "Unable to sign in.";
      setError(message);
      dispatch(
        showSnackbar({
          message,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bbc-page" style={{zoom:0.82}}>
      <BbcHeader intl={intl} />
      <section className="lp-hero-area">
        <div className="lp-decor lp-decor-left" aria-hidden="true" />
        <div className="lp-decor lp-decor-right" aria-hidden="true" />
        <div className="lp-decor-line lp-decor-line-left" aria-hidden="true" />
        <div className="lp-decor-line lp-decor-line-right" aria-hidden="true" />

        <div className="bbc-container">
          <div className="lp-page">
            <main className="lp-main">
              <section className="lp-left">
               {/*  <p className="lp-kicker">BIENVENUE CHEZ</p>
                <h1>METUA&apos;A</h1>
                <p className="lp-intro">
                  Connectez-vous pour retrouver vos trajets,
                  réserver plus vite et voyager en toute confiance.
                </p> */}

                <img
                  className="lp-hero"
                  src={covoiturageImage}
                  alt="Covoiturage METUA'A"
                />

                <div className="lp-trust-row">
                  {trustItems.map(({ title, text, Icon }) => (
                    <article className="lp-trust-item" key={title}>
                      <span className="lp-trust-icon"><Icon /></span>
                      <div>
                        <h3>{title}</h3>
                        <p>{text}</p>
                      </div>
                    </article>
                  ))}
                </div>
              </section>

              <section className="lp-card-wrap">
                <form onSubmit={handleSubmit} className="lp-card" noValidate>
                  <h2>{intl.formatMessage({ id: "login.title" })}</h2>
                  <p className="lp-subtitle">{intl.formatMessage({ id: "login.subtitle" })}</p>

                  <label htmlFor="email">{intl.formatMessage({ id: "login.email.label" })}</label>
                  <div className="lp-input">
                    <span className="lp-leading"><EmailIcon /></span>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      placeholder={intl.formatMessage({ id: "login.email.placeholder" })}
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <label htmlFor="password">{intl.formatMessage({ id: "login.password.label" })}</label>
                  <div className="lp-input">
                    <span className="lp-leading"><LockIcon /></span>
                    <input
                      id="password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      autoComplete="current-password"
                      placeholder={intl.formatMessage({ id: "login.password.placeholder" })}
                      value={form.password}
                      onChange={handleChange}
                      required
                    />
                    <button
                      type="button"
                      className="lp-trailing"
                      aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                      onClick={() => setShowPassword((current) => !current)}
                    >
                      <EyeIcon visible={showPassword} />
                    </button>
                  </div>

                  <div className="lp-row">
                    <label className="lp-remember" htmlFor="rememberMe">
                      <input
                        id="rememberMe"
                        type="checkbox"
                        checked={rememberMe}
                        onChange={(event) => setRememberMe(event.target.checked)}
                      />
                      {intl.formatMessage({ id: "login.rememberMe" })}
                    </label>
                    <a href="/" className="lp-forgot">{intl.formatMessage({ id: "login.forgotPassword" })}</a>
                  </div>

                  {error ? <p className="lp-error">{error}</p> : null}

                  <button type="submit" className="lp-submit" disabled={isSubmitting}>
                    {isSubmitting
                      ? intl.formatMessage({ id: "login.submitting" })
                      : intl.formatMessage({ id: "login.submit" })}
                  </button>

                  <div className="lp-divider">
                    <span>{intl.formatMessage({ id: "login.continueWith" })}</span>
                  </div>

                  <div className="lp-social-grid">
                    <button type="button" className="lp-social-btn">
                      <GoogleIcon />
                      {intl.formatMessage({ id: "login.google" })}
                    </button>
                    <button type="button" className="lp-social-btn">
                      <FacebookIcon />
                      {intl.formatMessage({ id: "login.facebook" })}
                    </button>
                  </div>

                  <p className="lp-signup">
                    {intl.formatMessage({ id: "login.noAccount" })} <Link to="/">{intl.formatMessage({ id: "login.createAccount" })}</Link>
                  </p>
                </form>
              </section>
            </main>
          </div>
        </div>
      </section>
      <BbcFooter intl={intl} />
    </div>
  );
};

export default Login;